module.exports = __FOREMAN_VENDOR__APOLLO_CLIENT__;


//////////////////
// WEBPACK FOOTER
// external "__FOREMAN_VENDOR__APOLLO_CLIENT__"
// module id = @apollo/client
// module chunks = 0 1 2